<div class="row pt-2 pb-2">
    <div class="col-sm-9">
        <h4 class="page-title">Manage Toilet Address</h4>
    </div>
    <div class="col-sm-3">
        <div class="btn-group float-sm-right">
            <button type="button" (click)="ClearForm()" data-toggle="modal" data-target="#toilet_modal" class="btn btn-outline add_btn btn-sm">
                <i class="zmdi zmdi-plus mr-1"></i>Add Toilet
            </button>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <!-- <h5 class="card-title">Responsive Table</h5> -->
                 <div class="row mb-3">
                    <div class="form-group col-md-4">
                        <label>Zone</label>
                        <ng-select [items]="filterZoneList" bindLabel="zone_name" bindValue="id"
                            placeholder="Select Zones" [multiple]="true" appendTo="body"
                            (change)="onFilterZoneChange($event)"
                            [(ngModel)]="filterZoneIds">
                        </ng-select>
                    </div>
                    <div class="form-group col-md-4" >
                        <label>Ward</label>
                        <ng-select [items]="filterWardList" bindLabel="ward_name" bindValue="id"
                            placeholder="Select Wards" [multiple]="true" appendTo="body"
                            (change)="onFilterWardChange($event)"
                            [(ngModel)]="filterWardIds">
                        </ng-select>
                    </div>
                    <!-- <div class="form-group col-md-4" style="margin-top: 15px;">
                        <button class="btn btn-outline-danger btn-sm" (click)="resetFilter()">Clear</button>
                    </div> -->
                </div>
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Zone</th>
                                <th>Ward</th>
                                <th>Toilet ID</th>
                                <th>MoHUA (GTL ID)</th>
                                <th>Toilet Name</th>
                                <th style="white-space: normal;">Address</th>
                                <th style="white-space: normal;">Landmark</th>
                                <th>Lat Lng</th>
                                <!-- <th>Toilet Type</th> -->
                                <th>Assign Device</th>
                                <th>Supervisor</th>
                                <!-- <th>Assign Device Date</th> -->
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let tData of toiletRowdata; let i = index">
                                <td>{{i+1}}</td>
                                <td>{{tData.zone_name}}</td>
                                <td>{{tData.ward_name}}</td>
                                <td style="white-space: normal;">{{tData.toilet_no}}</td>
                                <td style="white-space: normal;">{{tData.google_toilet_id}}</td>
                                <td style="white-space: normal;">{{tData.toilet_name}}</td>
                                <td style="white-space: normal;">{{tData.address}}</td>
                                <td style="white-space: normal;">{{tData.landmark}}</td>
                                <td>{{tData.lattitude}} , {{tData.longitude}}</td>
                                <!-- <td>{{tData.toilet_type}}</td> -->
                                <td>{{tData.device_id}}</td>
                                <td>{{tData.supervisor_name}} ({{tData.supervisor_mobile}})</td>
                                <!-- <td>{{tData.device_assignment_date | date:'dd-MM-yyyy'}}</td> -->
                                <td style="text-align: center;">
                                    <a data-toggle="modal" data-target="#toilet_modal" (click)="EditToilet(tData)" style="color: dodgerblue">
                                        <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                    </a><span style="margin-left: 15px;"></span>
                                    <a (click)="DeleteToilet(tData.toilet_id)" style="color: red;">
                                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                    </a>
                                    <a *ngIf="roleId==0" title="Send sms" type="button" class="ml-2"
                                        (click)="sendSmsNotification(tData.device_id)">
                                        <i class="fa fa-comment fa-lg" aria-hidden="true"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   
                </div>
            </div>
        </div>
    </div>
</div>
<div class="loader-wrapper" id="loading" *ngIf="isLoading" >
    <div class="loader-card">
        <div class="spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring delay"></div>
            <div class="core"></div>
        </div>
    </div>
</div>
<div id="toilet_modal" class="modal fade hide" role="dialog">
    <form action="#" #masterToiletForm="ngForm">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title">Toilet Details</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="form-row">
                        <!-- Toilet Name -->
                        <input type="hidden" id="toilet_id" name="toilet_id">
                        <div class="form-group col-md-3">
                            <label for="toilet_name">Toilet Name</label>
                            <input type="text" id="toilet_name" name="toilet_name" class="form-control form-control-sm"
                                [(ngModel)]="toiletForm.toilet_name" required #toilet_name="ngModel">
                        </div>
                        <div class="form-group col-md-3">
                            <label for="toilet_no">Toilet No</label>
                            <input type="text" id="toilet_no" name="toilet_no" class="form-control form-control-sm"
                                [(ngModel)]="toiletForm.toilet_no" required #toilet_no="ngModel">
                        </div>

                        <div class="form-group col-md-3">
                            <label for="google_toilet_id">MoHUA (GTL ID)</label>
                            <input type="text" id="google_toilet_id" name="google_toilet_id" class="form-control form-control-sm"
                                [(ngModel)]="toiletForm.google_toilet_id" required #google_toilet_id="ngModel">
                        </div>

                        <div class="form-group col-md-3">
                            <label for="supervisor_name">Supervisor Name</label>
                            <input type="text" id="supervisor_name" name="supervisor_name" class="form-control form-control-sm"
                                [(ngModel)]="toiletForm.supervisor_name" required #supervisor_name="ngModel">
                        </div>

                        <div class="form-group col-md-3">
                            <label for="supervisor_mobile">Supervisor Mobile</label>
                            <input type="text" id="supervisor_mobile" name="supervisor_mobile" class="form-control form-control-sm"
                                [(ngModel)]="toiletForm.supervisor_mobile" required #supervisor_mobile="ngModel">
                        </div>
                        <!-- Address -->
                        <div class="form-group col-md-3">
                            <label for="address">Address</label>
                            <input type="text" id="address" name="address" class="form-control form-control-sm"
                                [(ngModel)]="toiletForm.address" required #address="ngModel">
                        </div>
            
                        <!-- Pin Code -->
                        <div class="form-group  col-md-3">
                            <label for="landmark">Landmark</label>
                            <input type="text" id="landmark" name="landmark" class="form-control form-control-sm"
                                [(ngModel)]="toiletForm.landmark" required #landmark="ngModel">
                        </div>
            
                        <!-- Landmark -->
                        <div class="form-group col-md-3">
                            <label for="lattitude">Lattitude</label>
                            <input type="text" id="lattitude" name="lattitude" class="form-control form-control-sm"
                                [(ngModel)]="toiletForm.lattitude" required #lattitude="ngModel">
                        </div>
            
                        <div class="form-group  col-md-3">
                            <label for="longitude">Longitude</label>
                            <input type="text" id="longitude" name="longitude" class="form-control form-control-sm"
                                [(ngModel)]="toiletForm.longitude" required #longitude="ngModel">
                        </div>
            
                        <div class="form-group col-md-3">
                            <label for="toilet_type">Toilet Type</label>
                            <input type="text" id="toilet_type" name="toilet_type" class="form-control form-control-sm"
                                [(ngModel)]="toiletForm.toilet_type" required #toilet_type="ngModel">
                        </div>
            
                        <div class="form-group  col-md-3">
                            <label for="longitude">Assign Device ID</label>
                            <!-- <input type="text" id="device_id" name="device_id" class="form-control form-control-sm" [(ngModel)]="toiletForm.device_id" required #device_id="ngModel"> -->
                            <ng-select [items]="deviceDataArr" bindLabel="device_id" bindValue="id"
                                placeholder="Select Device" appendTo="body" name="device_id"
                                (change)="GetDeviceName($event.id)"
                                id="device_id"
                                [(ngModel)]="toiletForm.device_id">
                            </ng-select>
                        </div>
            
                        <div class="form-group  col-md-3">
                            <label for="longitude">Zone</label>
                            <ng-select [items]="zoneDataArr" bindLabel="zone_name" bindValue="id"
                                placeholder="Select Zone" appendTo="body" name="zone_name"
                                (change)="GetZoneName($event.id)"
                                id="zone_id"
                                [(ngModel)]="toiletForm.zone_id">
                            </ng-select>
                        </div>
                        <div class="form-group  col-md-3">
                            <label for="longitude">Ward</label>
                            <ng-select [items]="wardDataArr" bindLabel="ward_name" bindValue="id"
                                placeholder="Select Ward" appendTo="body" name="ward_name"
                                id="ward_id"
                                [(ngModel)]="toiletForm.ward_id">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="reset" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-primary" (click)="onSubmit()">
                        {{ isEditMode ? 'Update' : 'Save' }}</button>
                </div>
            </div>
        </div>
    </form>
</div>
